import { render, staticRenderFns } from "./VList.vue?vue&type=template&id=c22f6988"
import script from "./VList.vue?vue&type=script&lang=js"
export * from "./VList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports